<template>
	<div></div>
</template>

<script>
import { finalizeDibsEasy } from '@/api/modules/confirm'

export default {
	mounted() {
		const paymentID = this.$route.query.paymentid

		if (paymentID) {
			const orderID = this.$cookies.get(`letbane-order-${paymentID}`)
			finalizeDibsEasy(paymentID, orderID, true).then((response) => {
				if (response.responseBody.error === 'FinalizationWindowExceeded') {
					this.$router.push({ path: '/error', query: { error: 'paymenttimeout' } })
					return
				}

				if (!response.ok) {
					this.$router.push({ path: '/error' })
					return
				}

				this.$router.replace({ path: '/receipt', query: { orderId: response.responseBody.orderId } })
			})
		} else {
			this.$router.replace({ path: '/' })
		}
	},
}
</script>

<style lang="scss" scoped>
</style>